import { useTranslation } from 'react-i18next';
import { TopBar } from '../../components/TopBar';
import { useApp } from '../../store';
import { NEWS_VERSION } from '../../lib/news';
import { GamePanels } from '../shared/GamePanels';

/** Shell historique — comportement inchangé pour les joueurs V1. */
export function GameShellV1() {
  const { t } = useTranslation('panels');
  const {
    user,
    panel,
    interfaceHidden,
    setInterfaceHidden,
    empireFlagsVisible,
    setEmpireFlagsVisible,
    setPanel,
    setNewsOpen,
  } = useApp();

  return (
    <>
      {!interfaceHidden && (
        <>
          <TopBar />
          <GamePanels />
        </>
      )}
      {!interfaceHidden && !user && panel === 'none' && (
        <button
          type="button"
          onClick={() => setPanel('auth')}
          className="absolute bottom-6 left-1/2 z-20 -translate-x-1/2 rounded-full bg-[var(--accent)] px-5 py-3 text-sm font-semibold text-[#1a1408] shadow-lg sm:hidden"
        >
          {t('app.play')}
        </button>
      )}
      {(panel === 'none' || interfaceHidden) && (
        <div className="absolute bottom-3 left-3 z-[60] flex items-center gap-1.5">
          <button
            type="button"
            onClick={() => setInterfaceHidden(!interfaceHidden)}
            title={interfaceHidden ? t('app.showGame') : t('app.mapOnly')}
            aria-label={interfaceHidden ? t('app.showHud') : t('app.hideHud')}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 bg-[#0b1219]/75 text-white/80 shadow-lg backdrop-blur-md transition hover:border-[var(--accent)] hover:text-[var(--accent)]"
          >
            {interfaceHidden ? (
              <svg aria-hidden="true" viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M3 12s3.4-6 9-6 9 6 9 6-3.4 6-9 6-9-6-9-6Z" />
                <circle cx="12" cy="12" r="2.5" />
              </svg>
            ) : (
              <svg aria-hidden="true" viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="m3 3 18 18M10.7 6.15A8.8 8.8 0 0 1 12 6c5.6 0 9 6 9 6a15 15 0 0 1-2.1 2.8M6.2 6.2C4.2 7.7 3 12 3 12s3.4 6 9 6c1.5 0 2.8-.4 4-1" />
                <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
              </svg>
            )}
          </button>
          <button
            type="button"
            onClick={() => setEmpireFlagsVisible(!empireFlagsVisible)}
            title={empireFlagsVisible ? t('app.hideFlags') : t('app.showFlags')}
            aria-label={empireFlagsVisible ? t('app.hideFlags') : t('app.showFlags')}
            aria-pressed={empireFlagsVisible}
            className={`flex h-9 w-9 items-center justify-center rounded-full border shadow-lg backdrop-blur-md transition ${
              empireFlagsVisible
                ? 'border-[var(--accent)]/60 bg-[var(--accent)]/20 text-[var(--accent)]'
                : 'border-white/20 bg-[#0b1219]/75 text-white/80 hover:border-[var(--accent)] hover:text-[var(--accent)]'
            }`}
          >
            <svg aria-hidden="true" viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="1.8">
              <path d="M5 4v16" strokeLinecap="round" />
              <path d="M5 5h11.5a1 1 0 0 1 .8 1.6L15.5 9l1.8 2.4a1 1 0 0 1-.8 1.6H5" strokeLinejoin="round" />
            </svg>
          </button>
          {user && !user.needsEmpireName && (
            <button
              type="button"
              onClick={() => {
                setPanel('none');
                setNewsOpen(true);
              }}
              title={t('app.openNews')}
              aria-label={t('app.openNewsAria')}
              className={`relative flex h-9 w-9 items-center justify-center rounded-full border text-xs font-bold tracking-wide shadow-lg backdrop-blur-md transition ${
                (user.newsSeenVersion ?? 0) < NEWS_VERSION
                  ? 'border-[var(--accent)]/60 bg-[var(--accent)]/20 text-[var(--accent)]'
                  : 'border-white/20 bg-[#0b1219]/75 text-white/80 hover:border-[var(--accent)] hover:text-[var(--accent)]'
              }`}
            >
              N
              {(user.newsSeenVersion ?? 0) < NEWS_VERSION && (
                <span
                  aria-hidden
                  className="absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full bg-[var(--accent)] ring-2 ring-[#0b1219]/75"
                />
              )}
            </button>
          )}
        </div>
      )}
    </>
  );
}
